import { Injectable } from '@angular/core';
import { BaseService } from '../../../../core/base/base.service';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../../../../core/services/auth.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MetrikMotifModel } from '../../../../core/models/metrik-motif.model';
import { MetrikTypeEnum } from '../../../../core/enums/metrik-type.enum';
import { MetrikMotifHelper } from '../../../../core/helpers/metrik-motif.helper';

@Injectable({
  providedIn: 'root',
})
export class MetrikMotifService extends BaseService<MetrikMotifModel> {
  defaultSort = 'label';
  defaultSortOrder = 'asc';

  constructor(
    public http: HttpClient,
    public authService: AuthService,
  ) {
    super(http, 'metrik-motif', authService);
  }

  /** Motifs actifs, tous types confondus, avec le libellé d'affichage (sélecteurs des génériques). */
  findActive(): Observable<MetrikMotifModel[]> {
    return this.findAll(null, 'all', 'label', 'asc', '', { isArchive: false }).pipe(
      map(res => res.data.map(motif => ({ ...motif, display: MetrikMotifHelper.display(motif) }))),
    );
  }

  /** Motifs actifs typés Compétence (modales de création / édition du ticket compétence). */
  findCompetenceMotifs(): Observable<MetrikMotifModel[]> {
    return this.findAll(null, 'all', 'label', 'asc', '', { isArchive: false, type: MetrikTypeEnum.COMPETENCE }).pipe(
      map(res => res.data),
    );
  }
}
